import React from "react";
import img1 from "../../images/manufacturerBenefits/service (1).svg";
import img2 from "../../images/manufacturerBenefits/organic.svg";
import img3 from "../../images/manufacturerBenefits/search.svg";
import { Row, Col } from "react-bootstrap";
import BenefitsCard from "../BenefitsCard/BenefitsCard";
import { Container } from "@material-ui/core";

export default function LogisticStackBenefits() {
  const benefits = [
    {
      img: img1,
      title: "Enhanced Operational Efficiency ",
      bodycopy: "Streamline the management of transport and storage requests, reducing delays and ensuring timely execution."    },
    {
      img: img2,
      title: "Improved Visibility and Control",
      bodycopy: " Gain real-time insights into the status and progress of each request, allowing for proactive decision-making.",
    },
    {
      img: img3,
      title: "Optimized Resource Allocation",
      bodycopy:
        " Efficiently assign resources, ensuring the right assets and logistics providers are used for the task.",
    },
    {
        img: img3,
        title: "Better Risk Management",
        bodycopy:
          " With detailed tracking and reporting, manage risks associated with transport delays, asset damage, or storage issues. ",
      },
      {
        img: img3,
        title: "Efficiency and Time-Saving",
        bodycopy:
          " Automated booking management helps reduce manual tasks by organizing and streamlining the entire process. Clients can create, update, and manage bookings faster, allowing for more efficient operations.",
      },

      {
        img: img3,
        title: "Real-Time Tracking",
        bodycopy:
          " With booking management, clients can track the status of their bookings in real-time, ensuring that they have up-to-date information about the progress of each order.",
      },
      {
        img: img3,
        title: "Improved Communication",
        bodycopy:
          "  Booking management systems allow seamless communication between customers, drivers, and logistics providers, ensuring everyone is informed at every stage of the process.",
      },
      {
        img: img3,
        title: "Efficient Resource Allocation",
        bodycopy:
          " By mapping bookings with transport users or trip IDs, booking management ensures that resources (like drivers and vehicles) are allocated efficiently, minimizing delays and optimizing schedules.",
      },
      {
        img: img3,
        title: "Data Accuracy and Security",
        bodycopy:
          "   Booking management systems reduce human error by automating data entry, ensuring that all information is accurate and securely stored.",
      },
      {
        img: img3,
        title: "Cost-Effectiveness",
        bodycopy:
          "  With optimized workflows, fewer manual interventions are needed, which can result in cost savings related to labor and resource management.",
      },
      {
        img: img3,
        title: "Customization and Flexibility",
        bodycopy:
          "  Clients can tailor the booking management system to fit their specific needs, whether it's scheduling, invoicing, or handling multiple types of bookings and statuses.",
      },


      
  ];
  return (
    <div className="">
          <Container className="subSectionWrapper ">
      <h2 className="text-center container-title mb-4">
          Benefits
      </h2>
      <Row>
        {benefits.map((e, i) => {
          return (
            <Col md={4} key={i} className="d-flex">
              <BenefitsCard  src={e.img} title={e.title} bodycopy={e.bodycopy} />
            </Col>
          );
        })}
      </Row>
      </Container>
    </div>
  );
}
